'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorHexValue = undefined;

var _colorConstants = require('./colorConstants');

var getColorHexValue = exports.getColorHexValue = function getColorHexValue(colorName) {
  return _colorConstants.COLORS[colorName] ? _colorConstants.COLORS[colorName].hex : null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/colors/colorHelper.js
// module id = 319
// module chunks = 0